module.exports = __webpack_public_path__ + "static/media/donbosco2.6cb77ca7.jpg";